/**
 * watchEverythingObservable.ts
 */
import watchEverythingRequest from './request';
import { Observable } from 'rxjs';

/**
 * Observable that retrieves the watch everything data.
 */
export default function watchEverythingObservable(channelName: string) {
  return new Observable((subscriber) => {
    watchEverythingRequest(channelName).then((data) => {
      subscriber.next(data);
      subscriber.complete();
    });
  });
}
